import React from 'react';
import styled from 'styled-components';
import landscapeImage from '../assets/landscape.jpeg';

const LandscapeSection = styled.section`
  position: relative;
  height: 400px;
  overflow: hidden;
  
  @media (max-width: 768px) {
    height: 300px;
  }
  
  @media (max-width: 576px) {
    height: 250px;
  }
`;

const LandscapeImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const ContentOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.4));
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 20px;
`;

const Title = styled.h2`
  color: white;
  font-size: 2.5rem;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.6);
  max-width: 800px;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
  
  @media (max-width: 576px) {
    font-size: 1.8rem;
  }
`;

const Landscape = () => {
  return (
    <LandscapeSection>
      <LandscapeImage src={landscapeImage} alt="Scenic Khaira Gali Landscape" />
      <ContentOverlay>
        <Title>Experience the stunning natural beauty of Khaira Gali</Title>
      </ContentOverlay>
    </LandscapeSection>
  );
};

export default Landscape;